import { Component, Input, OnInit } from '@angular/core';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { MatDialog } from '@angular/material/dialog';
import { ExcerciseProgressDialogComponent } from '../../excercise-progress-dialog/excercise-progress-dialog.component';
import { LearnCompletedDialogComponent } from '../../learn-completed-dialog/learn-completed-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-chapter-learn-tab',
  templateUrl: './chapter-learn-tab.component.html',
  styleUrls: ['./chapter-learn-tab.component.css']
})
export class ChapterLearnTabComponent implements OnInit {

  @Input() tabSubject: string;
  @Input() tabTopicData: any;
  @Input() tabBannerData:any;
  @Input() expandRowIndex:number = -1;

  chapterViewMoreStatus: boolean = false;
  selectedexpandRowIndex:number = -1;
  documentsData: any;
  constructor(public selfLearnService:SelfLearnService, public dialog: MatDialog, public router: Router) { }

  ngOnInit(): void {
    //this.openExcerciseProgressDialog();
    //this.learnChapterCompleteDialog();
    this.getDocuments();
  }

  chapterViewMore() {
    this.chapterViewMoreStatus = !this.chapterViewMoreStatus;
  }

  getDuration(){
    
    return this.convertMinutestoHHmm(this.tabBannerData?.totalDuration);
  }

  openExcerciseProgressDialog() {
    this.dialog.open(ExcerciseProgressDialogComponent, {
      width: '768px', 
      panelClass: 'SLV2-excercise-progress-modal', 
      data: {
        dialogSection: 1,
      } 
    });
  }

  learnChapterCompleteDialog(){
    this.dialog.open(LearnCompletedDialogComponent, {
      width: '620px',
      panelClass: 'mweb-stiky-bottom',
    });
  }
  convertMinutestoHHmm(duration:any ){ 
    let sec = duration.toString().replace(/\D/g,'');
    sec = Number(sec);
    var hour = Math.floor(sec / 3600);
    var minutes = Math.floor(sec % 3600 / 60);
    var seconds = Math.floor(sec % 3600 % 60);
    if(hour > 0){
      return hour +"h "+ minutes+"m";
    }
    else if(minutes >0 && seconds>0)
    {
      return minutes+"m "+ seconds+"s";
    }
    else if(hour <=0 && minutes<=0){
      return seconds+"s";
    }
    else if(hour <=0 && minutes > 0){
      return minutes+"m";

    }
    else{
      return hour +"h "+ minutes+"m";
    }
   
  }

  setExpandRowIndex(index){
    this.expandRowIndex = index;
  }
  navigateToDocs(){
    localStorage.setItem('documentsData',JSON.stringify(this.documentsData));
    this.router.navigate([`selfLearn-V2/documents`]);
  }
  getDocuments(){
    this.selfLearnService.getDocumentsForExamChapterSubtenant().subscribe((res:any) => {
      this.documentsData = res.data;
      console.log(res);
    })
  }
   
}
